import { h, Component } from 'preact';
import s from 'components/bolt/trailerOverlay/trailerOverlay.sss';
import BurgerMenu from 'components/bolt/burgerMenu/burgerMenu';
import 'store/bolt/trailerOverlay';
import { joinClasses, accessNested } from 'utils/utils';
import parseQueryString from 'utils/parseQueryString';
import VideoPlayer from 'components/bolt/videos/player';
import Store from 'store/store';
import HTML from 'components/core/html/html';

export default class TrailerOverlay extends Component {
	constructor(props) {
		super(props);

		this.state = {
			closed: false,
			videoLoaded: false
		};

		this.handleLoaded = this.handleLoaded.bind(this);
		this.toggleOverlayOpen = this.toggleOverlayOpen.bind(this);
		this.checkIfOverlayShouldShow = this.checkIfOverlayShouldShow.bind(this);

		this.overlayOpenTimer = 0;

		this.disabled = parseQueryString()['no-overlay'];
	}

	componentDidMount() {
		this.checkIfOverlayShouldShow(null, true);
		Store.on('SET_ACTIVE_PAGE', this.checkIfOverlayShouldShow);
	}

	componentWillUnmount() {
		window.clearTimeout(this.timeout);
		window.clearInterval(this.interval);
		Store.off('SET_ACTIVE_PAGE', this.checkIfOverlayShouldShow);
		this.toggleOverlayOpen(false);
	}

	checkIfOverlayShouldShow(activePage, initial) {
		window.clearTimeout(this.timeout);
		window.clearInterval(this.interval);

		const overlayTriggered = accessNested(this.props, 'store.trailerOverlay.overlayTriggered', false);
		const disableForGoogleBot = accessNested(this.props, 'data.disableForGoogleBot', false);
		const isGoogleBot = /Googlebot/i.test(navigator.userAgent);

		if (overlayTriggered || (disableForGoogleBot && isGoogleBot)) return;

		if (!activePage) activePage = accessNested(this.props, 'store.activePage');
		let inclusions = accessNested(this.props, 'data.inclusions', '');

		if (inclusions) {
			inclusions = inclusions.split(',').map(page => page.trim());
		}

		const disableOnLanding = this.props.manual && initial;

		if ((inclusions.length === 0 || inclusions.indexOf(activePage) > -1) && !this.disabled && !disableOnLanding) {
			const delay = this.props.data.delay || 0;

			this.timeout = window.setTimeout(() => {
				this.toggleOverlayOpen(true);
				this.interval = window.setInterval(() => {
					this.overlayOpenTimer += 1;
				}, 1000);
			}, delay * 1000);
		}
	}

	toggleOverlayOpen(open, e) {
		if (!open && e?.target?.id === 'youtubeCookieSettings') {
			return;
		}
		if (!open) {
			window.clearInterval(this.interval);
			let value = Math.floor(this.overlayOpenTimer / 10) * 10;
			if (this.overlayOpenTimer > 100) {
				value = '100+';
			}
			Store.emit('POWSTER_GA_EVENT_TRACK', 'trailer-bounce', 'trailer', value);
		}

		if (e?.target && !e.target.className?.includes('burgerMenu') && !e.target.className.includes(s.wrapper)) {
			return;
		}

		Store.emit('TOGGLE_TRAILER_OVERLAY', open);
	}

	handleLoaded() {
		this.setState({ videoLoaded: true });
	}

	render() {
		const { videoLoaded } = this.state;
		const { data, store } = this.props;

		const overlayOpen = !this.disabled && accessNested(store, 'trailerOverlay.overlayOpen', false);
		const fontVariables = accessNested(store, 'appData.styling.fontVariables.galleryAnnotations', {});
		const { video, annotation } = data;
		let videoSubObject = Object.values(video).find(value => value && typeof value === 'object');
		// If the video object is not nested, consider it to be the video data itself, otherwise take the first subobject
		let activeVideo = videoSubObject || video;

		return (
			<div
				class={joinClasses(s.wrapper, (videoLoaded && overlayOpen) && s.visible)}
				onClick={(e) => this.toggleOverlayOpen(false, e)}
			>
				<BurgerMenu
					type={overlayOpen ? 'close' : 'burger'}
					trailerOverlay
					extraClass={s.closeButton}
				/>
				{overlayOpen && (
					<VideoPlayer
						ref={ref => this.player = ref}
						extraClass={s.player}
						activeVideo={activeVideo}
						onEnded={() => this.toggleOverlayOpen(false)}
						onLoaded={this.handleLoaded}
						hiddenPlaylist
						overrideStyles
						isTrailerOverlay
					/>
				)}
				{annotation && (
					<div style={fontVariables.galleryAnnotations} class={s.annotation}>
						<HTML markdown content={annotation} />
					</div>
				)}
			</div>
		);
	}
}
